require('./bootstrap');

window.Vue = require('vue').default;

Vue.component('reservations-calendar', require('./components/ReservationsCalendar.vue').default);

const app = new Vue({
    el: '#app',
});

// Delete work button confirm.
import Swal from 'sweetalert2';

window.deleteConfirm = function (formId) {
    Swal.fire({
        icon: 'warning',
        text: 'Вы точно хотите удалить?',
        showCancelButton: true,
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        confirmButtonColor: '#e3342f',
    }).then((result) => {
        if (result.isConfirmed) {
            document.getElementById(formId).submit();
        }
    });
}

window.viewReservationDetails = function (reservationId) {
    $.ajax({
        url: `/reservations/${reservationId}`
    })
        .then(function (resp) {
            Swal.fire({
                title: 'Детали записи',
                html: resp,
                showConfirmButton: true,
                focusConfirm: false
            })
        })
        .catch(err => console.log(err));
}

import 'jquery-ui/ui/widgets/datepicker'

// Attach time-picker functionality.
$('.datetimepicker-group, .datetimepicker-input').datetimepicker({
    format: 'HH:mm',
    allowInputToggle: true,
    icons: {
        "up": "far fa-caret-square-up",
        "down": "far fa-caret-square-down"
    }
});
